import { render, staticRenderFns } from "./ClientsReports.vue?vue&type=template&id=4fd555fc&scoped=true&"
import script from "./ClientsReports.vue?vue&type=script&lang=js&"
export * from "./ClientsReports.vue?vue&type=script&lang=js&"
import style0 from "./ClientsReports.vue?vue&type=style&index=0&id=4fd555fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd555fc",
  null
  
)

export default component.exports